<template>
  <app-tooltip v-if="paymentMethod">
    <button
      type="button"
      :aria-label="`${t('literal.payment_method')}: ${paymentMethod.label}`"
    >
      <img
        class="payment-method__logo"
        :src="paymentMethod.image"
        :alt="t('literal.logo_of_x', { x: paymentMethod.label })"
        :width="size * 12"
      >
    </button>

    <template #popper>
      <p>{{ paymentMethod.label }}</p>
    </template>
  </app-tooltip>
</template>

<script setup>
import { computed, defineAsyncComponent } from 'vue'
import { usePaymentProfileStore } from '@/stores/PaymentProfileStore'
import { useI18n } from '@/vendors/i18n'

const AppTooltip = defineAsyncComponent(() => import('&/atoms/AppTooltip'))

const { payment_methods } = usePaymentProfileStore()

const { type } = defineProps({
  type: { type: String, required: true },
  size: { type: Number, default: 2.5 }
})

const { t } = useI18n()

const paymentMethod = computed(() => payment_methods.find(payment_method => payment_method.value === type))
</script>
